import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/ebooks',
        component: () => import('@/pages/ebooks/EbookIndex.vue'),
        props: true,
        children: [
            {
                name: 'ebooks-index',
                path: '',
                component: () => import('@/components/ebooks/EbooksView.vue'),
                meta: {
                    title: 'Ebooks',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) =>
                        gateKeeper.userHasPermission('can access system ebooks') ||
                        gateKeeper.userHasGroupPermission('can access system ebooks'),
                },
                props: true,
            },
        ],
    },
];
